import React, { useState, useEffect, useRef } from "react";

export const useCountdown = (initialTimer, initialPlaying = false) => {
    const milisecond = useRef(initialTimer * 1000);
    const previous = useRef(milisecond);
    const [timer, setTimer] = useState(initialTimer);
    const [timerOutput, setOutout] = useState('00:00');
    const [isTimerRunning, setIsTimerRunning] = useState(initialPlaying);
    const animationFrameRef = useRef(null); // Track the animation frame
    
    const setResetTimer = () => {
        // Cancel any pending animation frame
        if (animationFrameRef.current !== null) {
            cancelAnimationFrame(animationFrameRef.current);
            animationFrameRef.current = null;
        }
        
        setIsTimerRunning(false);
        setTimer(0);
        milisecond.current = (initialTimer * 1000);
        previous.current = (initialTimer * 1000);
        setOutout('00:00');
    }
    useEffect(() => {
        if (!isTimerRunning) {
            // Cancel animation frame when timer stops
            if (animationFrameRef.current !== null) {
                cancelAnimationFrame(animationFrameRef.current);
                animationFrameRef.current = null;
            }
            return;
        }

        let effectInitialMs = milisecond.current;
        let effectInitialTimeStamp;

        const step = (timestampMs) => {
            if (effectInitialTimeStamp === undefined)
                effectInitialTimeStamp = timestampMs;
            const elapsed = timestampMs - effectInitialTimeStamp;
            milisecond.current = effectInitialMs + elapsed;
            const seconds = Math.floor(milisecond.current / 1000);
            const isUpdate = seconds !== Math.floor(previous.current / 1000);
            previous.current = milisecond.current;
            if (isUpdate) {
                setTimer(seconds);
                convertTime(seconds)
            }
            if (isTimerRunning) {
                animationFrameRef.current = window.requestAnimationFrame(step);
            }
        };

        const convertTime = (count) => {
            let hours = Math.floor(count / 3600);
            let minutes = Math.floor(count / 60) - hours * 60;
            let seconds = parseFloat(count % 60).toFixed(0);
            if (hours < 10) hours = `0${hours}`;
            if (minutes < 10) minutes = `0${minutes}`;
            if (seconds < 10) seconds = `0${seconds}`;
            setOutout(`${minutes}:${seconds}`);
        }

        animationFrameRef.current = window.requestAnimationFrame(step);

        return () => {
            console.log("cancelAnimationFrame(pause)", animationFrameRef.current, milisecond.current);
            if (animationFrameRef.current !== null) {
                cancelAnimationFrame(animationFrameRef.current);
                animationFrameRef.current = null;
            }
        };
    }, [isTimerRunning]);

    return [timer, timerOutput, isTimerRunning, setIsTimerRunning, setResetTimer];
};